import { Providers } from "@/pages/Providers/Providers";

export const ProvidersRoutes = () => <Providers basePath="/providers" />;
